export const activities = [
  "Code",
  "Paint",
  "Solder",
  "Game",
  "Go for a Walk",
  "Read",
  "Hacky Sack",
  "Bike Riding",
  "Study",
  "Music",
  "Writing",
];
